	import { useState, useContext, useEffect } from "react";
	import { Form, useRouteLoaderData, useSearchParams,useLoaderData, redirect, useSubmit, useNavigate } from "react-router-dom";
	import { useSelector, useDispatch } from "react-redux";
	import Modal  from "react-modal";
	
	import CartItem from '../components/Cart/CartItem';
	import { cartActions } from '../store/cart';
	import UserProfile from './UserProfile';
	import { getUserProfile, checkout, orderValidation, getSystemMsg, getLabConfig, setUpOrder} from '../utils/api';
	import PostLoginMsg from '../components/Login/PostLoginMsg';

	import MenuContext from '../store/MenuContext';
	import CartClasses from '../components/Cart/Cart.module.css';

	const DTCCCPROVIDER = await getLabConfig('DTCCCPROVIDER');

	const Cart = (props) => {
		const cartState = useSelector(state => state.cart);
		const [searchParams] = useSearchParams();
		const review=searchParams.get("review");
		const token = useRouteLoaderData('root');
		const nextPage = token ? '?review=1': '../login';
		const [userProfile,SystemMessage]=useLoaderData();

		const submit = useSubmit();
		const navigate = useNavigate();
		
		const [showMessageModal, setShowMessageModal] = useState(true);
		function closeMessageModal () {
			setShowMessageModal(false);
		}
		const order = cartState.items.map((item) => (
			item.TestId
			));

		const orderAAOE = cartState.items.map((item) => (
			JSON.stringify(item.AAOEAnswers)
			));
		const orderamt = cartState.items.map((item) => (
			item.DTCPrice
			));	
		const ordername = cartState.items.map((item) => (
			item.TestName.replaceAll(",","^")
			));	
		const [remove, setRemove] = useState([]);

		const checkLogin = (event) => {
		  event.preventDefault();
		  navigate(nextPage);
		};

		useEffect(() => {
		  if (review !== "1") return;
		  const validateAndRemove = async () => {
			  const result = await orderValidation(order);
			  setRemove(result);

			  // Always alert if Errors exist
			  if (result?.Errors?.length > 0) {
				const combinedErrors = result.Errors
				  .map((msg) => `${msg}\nThe test will be removed`)
				  .join("\n\n");
				alert(combinedErrors);
			  }

			  // Normalize types before comparing
			  const orderSet = new Set((order ?? []).map(String)); // e.g., ['PF','67','1001']

			  const testsToRemove = (result?.RemoveTests ?? [])
				.map(String)                               // e.g., ['67']
				.filter((testId) => orderSet.has(testId)); // now matches correctly

			  testsToRemove.forEach((testId) => removeFromCartHandler(testId));
			};
		  validateAndRemove();
		}, [review]); 

		const dispatch = useDispatch();
		const removeFromCartHandler = (id) => {
			dispatch(cartActions.remove(id));
		};
		const handleSetupOrder= async () => {
		  const orderData = {
			tests: order,
			testsAAOE: orderAAOE,
			testNames: ordername,
			amount: orderamt
			};
			const resData = await setUpOrder(orderData);
		};
		const submitHandler = async (event) => {
			event.preventDefault();
			console.log("submitting");
			await submit(event.currentTarget, { method: 'post' });
		};

    return (<div className={CartClasses.testInfo}>
    	      <div className={CartClasses.testInfoContent}>
    		     <h2 className={CartClasses.testTitle} >{review && 'REVIEW ' }CART</h2>
				<div >
					{review &&<UserProfile data = {userProfile} />}
				</div>
				<hr/>
  			    <Form  method="POST">
					{cartState.items.map((item) => (
						<div key={item.TestId}>
								 <CartItem
									item={{
									  key: item.TestId,
									  id: item.TestId,
									  name: item.TestName,
									  DTCPrice: item.DTCPrice,
									  shortDesc: item.DTCTestDescription,
									  AAOE: item.AAOE,
									  AAOEAnswers: item.AAOEAnswers,
									  RequiredTest: item.Required
									}}
								  />
								 
						</div>
					))}
					{cartState.totalQuantity === 0 && <div> Cart is empty</div>}
					<div className={CartClasses.buttonArea}>  
			  			<div className={CartClasses.navArea}>
			  		
			  				{cartState.totalQuantity >=1 && <div>Total: ${cartState.totalAmount.toFixed(2)}</div>}
			  				<nav>
							{!review &&
								<button onClick={checkLogin} className={CartClasses.buttonDarkBlue}>Complete Order</button>
							}
							{review && 
			  						cartState.totalQuantity >=1 && cartState.totalQuantity >=1 &&
									<div>
									{SystemMessage.length >0 &&
										<Modal 
											isOpen={showMessageModal}
											onRequestClose = {closeMessageModal}
											shouldCloseOnOverlayClick={false}
											contentLabel = "Attention"
											style={{
												overlay: { zIndex: 9999 },
												content: { zIndex: 10000 }
											  }}
											>
											<PostLoginMsg Message={SystemMessage} />
											<div className={CartClasses.buttonOK}>
												<button className={CartClasses.buttonDarkBlue} onClick={closeMessageModal}>ACCEPT</button>
											</div>
										</Modal>
									}
									<button
									  onClick={DTCCCPROVIDER === 'CLOVER' ? handleSetupOrder : submitHandler}
									  className={CartClasses.buttonDarkBlue}
									>
									  Checkout
									</button>

									</div>
								}
			  				</nav>
			  			</div>
			  		</div>
					<input type="hidden" name="order" value={order} />
					<input type="hidden" name="orderAAOE" value={orderAAOE} />
					<input type="hidden" name="orderamt" value={orderamt} />
					<input type="hidden" name="ordername" value={ordername} />
				  </Form>
				</div>
			</div>
	);
};

export default Cart;

export async function uploader() {
    const response = await getUserProfile(sessionStorage.getItem('Labtestid'));
	const resData = await response;
		return resData;
}
export async function action({ request, params }) {
  const data = await request.formData();
  const orderData = {
	tests: data.get('order').split(','),
	testsAAOE: data.get('orderAAOE').split(/},{/),
	testNames: data.get('ordername').split(','),
	amount: data.get('orderamt').split(',')
  };
  const resData = await checkout(orderData);

    if(resData?.xifin?.type==='xifin') {
	  console.log(resData);
	  const reURL=encodeURI('/CreditCardiFrameXIFIN/'+resData.xifin.amount+'/'+resData.xifin.firstname+'/'+resData.xifin.lastname+'/'+resData.xifin.address+'/'+resData.xifin.postalcode);
	  return redirect(reURL);
  } else if(resData.includes('RevSpring')) {
	  console.log('RevSpring redirect');
	  const revspring=JSON.parse(resData);
	  console.log(revspring);
	  console.log(revspring.RevSpringToken);
	  return redirect('/CreditCardiFrameREVSPRING/'+revspring.RevSpringToken);
  }else {
	  return redirect('/CreditCardFailed');
  }
}
export async function msgloader() {
    const response = await getSystemMsg("emergMsgPostLogin");
	const resData = await response;
		return resData;
}
export  async function loader() {
	return Promise.all([uploader(),msgloader()]);
}